import { render, staticRenderFns } from "./ViewFormRF06.vue?vue&type=template&id=1b2e18da&scoped=true"
import script from "./ViewFormRF06.vue?vue&type=script&lang=js"
export * from "./ViewFormRF06.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2e18da",
  null
  
)

export default component.exports